const getEnrollmentQuery = (version, params) => {
    return `query EnrollmentQuery {
      getEnrollmentResolvers_${version}(${params.join(', ')}) {
        accountInfo {
          accountName
        }
        userId
        userFirstName
        userLastName
        enrollmentData {
          fourthWindowLabel
          chosenClasseUid
          chosenDistrictUid
          chosenSchoolUid
          classesAndGroups {
            teacherName
            teacherSurname
            uid
            name
            gradeLevel
            classeOrGroup
            burstGroup
          }
          districts {
            uid
            instType
            name
          }
          schools {
            uid
            instType
            name
          }
          currentPeriod
          currentSchoolYear
          burstGroupUid
          isDemoClasse
          chosenSchoolWindowDates {
            BOY {
              startDate
              endDate
            }
            MOY {
              startDate
              endDate
            }
            EOY {
              startDate
              endDate
            }
            SUMMER {
              startDate
              endDate
            }
          }
          isChosenSchoolWindowDatesStrictlyEnforced
          studentsByGrade {
            students {
              externalId
              lastName
              firstName
              tk
              temporalId
              temporalInstId
              primaryId
            }
            grade
          }
          licensingConfiguration {
            licensingInfo
            gradeAvailabilityInfo {
              key
              measures
            }
          }
        }
        }
      }
      `;
};

export default getEnrollmentQuery;
